import React, { useMemo } from 'react';
import classNames from 'classnames';
import 'app/component/document-cell/DocumentCell.less';
import PureCell from '@alfa-retail-react/components/pure-cell';
import SuperEllipse from '@alfa-retail-react/components/super-ellipse';
import Loader from '@alfa-retail-react/components/loader';
import documentIcon from 'app/assets/glyph_document-lines_m.svg';

export interface DocumentCellProps {
    /**
     * Название документа.
     */
    documentName: string;

    /**
     * Ошибка к полю (по сути подзаголовок ячейки).
     */
    error?: string;

    /**
     * Иконка сбоку основной иконки документа.
     */
    addonIcon?: React.ReactNode;

    /**
     * CSS класс.
     */
    className?: string;

    /**
     * Устанавливает флажок необходимости прочтения справа от названия документа
     */
    required?: boolean;

    /**
     * Определяет, показывать ли иконку загрузки документа
     */
    isDownloading?: boolean;
}

/**
 * Компонент с ячейкой для документов.
 */
export const DocumentCell = React.forwardRef<HTMLDivElement, DocumentCellProps>(
    (props: DocumentCellProps, ref) => {
        const ellipseContent = useMemo(() => {
            if (props.isDownloading) {
                return <Loader show={props.isDownloading} />
            } else {
                return <img src={documentIcon} alt='документ'/>;
            }
        }, [props.isDownloading]);

        return (
            <PureCell
                ref={ref}
                className={classNames('documentCell', props.className)}
            >
                <PureCell.Graphics>
                    <SuperEllipse size={48} topAddons={props.addonIcon}>
                        {ellipseContent}
                    </SuperEllipse>
                </PureCell.Graphics>
                <PureCell.Content>
                    <PureCell.Main>
                        <PureCell.Text titleColor="primary" view="component">
                            {props.documentName}
                            {props.required && (
                                <span className="documentCellRequired">*</span>
                            )}
                        </PureCell.Text>

                        {props.error && (
                            <PureCell.Text
                                titleColor="negative"
                                view="primary-small"
                            >
                                {props.error}
                            </PureCell.Text>
                        )}
                    </PureCell.Main>
                </PureCell.Content>
            </PureCell>
        );
    },
);
